import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button } from "antd";
import HeaderLogo from "../header-logo";
import { FaCircle } from "react-icons/fa";

const { Header, Sider, Content } = Layout;

function SideBar({ children, routeConfig }) {
  const [collapsed, setCollapsed] = useState(() => {
    const stored = localStorage.getItem("sidebarCollapsed");
    return stored ? JSON.parse(stored) : false;
  });

  React.useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(collapsed));
  }, [collapsed]);
  const [openRoutes, setOpenRoutes] = useState({});
  const location = useLocation();

  const toggleDropdown = (routeName) => {
    setOpenRoutes((prev) => ({
      ...prev,
      [routeName]: !prev[routeName],
    }));
  };

  const getSelectedKey = () => {
    const match = routeConfig.find((route) => {
      if (route.children) {
        const childMatch = route.children.find(
          (child) => location.pathname === child.path
        );
        if (childMatch) return childMatch;
      }
      return location.pathname === route.path ? route : null;
    });
    return match?.children
      ? match.children.find((child) => location.pathname === child.path)?.name
      : match?.name;
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider trigger={null} collapsible collapsed={collapsed}  collapsedWidth={70}   width={250}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 64,
            padding: "0 16px",
          }}
        >
          <HeaderLogo collapsed={collapsed} />
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[getSelectedKey()]}>
          {routeConfig.map((route) => {
            const hasChildren = !!route.children?.length;

            return hasChildren ? (
              <Menu.SubMenu
              key={route.name}
              icon={<route.icon />}
              title={route.name}
              onTitleClick={() => toggleDropdown(route.name)}
              >
              {route.children.map((child) => (
                <Menu.Item key={child.name} icon={
                <FaCircle style={{ fontSize: "7px", color: "#fff", opacity: 0.5 }} />}>
                {/* <span style={{
                display: 'inline-block',
                maxWidth: '1px',
                height: '14px',
                borderRadius: '50%',
                backgroundColor: 'currentColor',
                opacity: 0.5,
                marginRight: '1px'
                }}></span>}>
                 */}
                <NavLink to={child.path} style={{ textDecoration: "none", fontSize: "12px" }}>
                  {child.name}
                </NavLink>
                </Menu.Item>
              ))}
              </Menu.SubMenu>
            ) : (
              <Menu.Item key={route.name} icon={<route.icon />}>
              <NavLink to={route.path} style={{ textDecoration: "none" }}>
              {route.name}
              </NavLink>
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>

      <Layout>
        <Header style={{ padding: 0, background: "#fff" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 52,
            }}
          />
        </Header>
        <Content style={{ margin: "24px 16px", padding: 24, background: "#fff" }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}

export default SideBar;
